import searchSharingApi from '../sharing/sagas/api';
import searchSharingLayout from '../sharing/sagas/layout';
import searchApi from './api';
import searchLayout from './layout';
import searchToasts from './toasts';

export default [
  searchApi(),
  searchToasts(),
  searchLayout(),
  searchSharingApi(),
  searchSharingLayout(),
];
